'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = function defaultState() {
    return {};
};

var subsectionReducers = function subsectionReducers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState();
    var action = arguments[1];

    if (action.type === _types.UI_GENERATE_SUBSECTIONS_STATE) {
        return action.payload.sectionsMenu.reduce(function (prev, cur) {
            if (cur.subSections) {
                return (0, _extends5.default)({}, prev, (0, _defineProperty3.default)({}, cur.name, false));
            }

            return prev;
        }, {});
    }

    if (action.type === _types.UI_TOGGLE_SECTION) {
        return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({}, action.payload.sectionName, !state[action.payload.sectionName]));
    }

    return state;
};

exports.default = subsectionReducers;
//# sourceMappingURL=subsection-reducers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/core-navigation-ui/subsection-reducers.js
 ** module id = 341
 ** module chunks = 0
 **/